<template>
  <div>
    <h3>{{caption}}</h3>
    <div :class="`glide_${_uid}`">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li
            v-for="(file, index) in fileList"
            :key="index"
            @click="openOverlay(index)"
            class="glide__slide"
          >
            <media-image :fileId="file"/>
          </li>
        </ul>
      </div>
      <div class="glide__bullets" data-glide-el="controls[nav]">
        <button
          class="glide__bullet"
          :class="{'glide__bullet--active':index == active}"
          :data-glide-dir="`=${(index*3)-3}`"
          v-for="index in bulletCount"
          :key="index"
        >{{index}}</button>
      </div>
    </div>

    <transition name="fade">
      <section
        role="dialog"
        aria-labelledby="modalTitle"
        v-if="openIndex != null"
        class="c-gallery__modal"
        @click="closeOverlay"
      >
        <figure class="c-gallery__modal__image">
          <media-image :fileId="fileList[openIndex]" v-if="openIndex != null"/>
          <loading v-else/>
        </figure>
        <footer class="c-gallery__modal__controls">
          <base-button
            type="button"
            :class="{disabled:openIndex === 0}"
            @click="gotoPrev"
            class="u-float-left"
          >Previous</base-button>
          <base-button
            type="button"
            :class="{disabled:openIndex == (fileList.length)-1}"
            @click="gotoNext"
            class="u-float-right"
          >Next</base-button>
        </footer>
      </section>
    </transition>
  </div>
</template>

<script>
import filesApi from "@/api/files";
import Glide, {
  Controls,
  Breakpoints
} from "@glidejs/glide/dist/glide.modular.esm";

export default {
  props: {
    caption: {
      type: String,
      default: "My Gallery"
    },
    fileId: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      openIndex: null,
      imgSrcArray: [],
      id: null,
      active: 1
    };
  },
  methods: {
    onCarouselMove(move) {
      document
        .querySelector(`.glide_${this._uid} .glide__bullet--active`)
        .classList.remove("glide__bullet--active"); //currently, glide js having issues with the active class
      const { steps } = move;
      this.active = (parseInt(steps) + 3) / 3;
    },
    gotoNext() {
      if (
        this.openIndex !== null &&
        this.openIndex < this.fileList.length - 1
      ) {
        this.openIndex += 1;
      }
    },
    gotoPrev() {
      if (this.openIndex !== null && this.openIndex > 0) {
        this.openIndex -= 1;
      }
    },
    openOverlay(index) {
      this.openIndex = index;
      document.addEventListener("keyup", this.handleKeyPress);
    },
    handleKeyPress(e) {
      if (e.keyCode == 39) {
        //right
        this.gotoNext();
      }

      if (e.keyCode == 37) {
        //left
        this.gotoPrev();
      }

      if (e.keyCode == 27) {
        //esc
        document.removeEventListener("keyup", this.handleKeyPress);
        this.openIndex = null;
      }
    },
    closeOverlay($event) {
      const noClose = ["button"];
      document.removeEventListener("keyup", this.handleKeyPress);
      if ($event && !noClose.includes($event.target.type)) {
        this.openIndex = null;
      }
    },
    getFile(fileId = null) {
      const vm = this;
      filesApi.read(fileId).then(file => {
        filesApi.readLink(file.link).then(response => {
          vm.setFileData(response.data);
        });
      });
    },

    setFileData(blob) {
      const vm = this;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        vm.imgSrcArray.push(base64data);
      };
    }
  },
  computed: {
    bulletCount() {
      if (!this.fileList) {
        return 0;
      }
      return Math.ceil(this.fileList.length / 3);
    },
    fileList() {
      return JSON.parse(this.fileId);
    }
  },
  beforeDestroy() {
    // document.body.removeEventListener('keyup');
  },
  created() {},
  mounted() {
    if (this.openIndex >= 0) {
    }
    new Glide(`.glide_${this._uid}`, {
      perView: 3,
      classes: {
        activeSlide: "pretend-class"
      }
    })
      .mount({ Controls, Breakpoints })
      .on("run.after", move => {
        this.onCarouselMove(move);
      });

    if (this.fileList) {
      this.fileList.forEach(file => {
        this.getFile(file);
      });
    }
    this.id = this._uid;
  }
};
</script>

<style lang="scss">
@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";

.fade-enter-active,
.fade-leave-active {
  transition: opacity ease-in-out 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.c-gallery {
  margin-bottom: 1em;
  &__modal {
    position: fixed;
    top: 0;
    left: 0;
    // transform:translate(-57vw,0);
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    padding: 5vmax;
    flex-direction: column;
    transform: translateZ(0);

    &__image {
      max-width: 90vw;
      max-height: 60vh;

      img {
        width: auto !important;
        max-height: 60vh;
      }
    }

    &__controls {
      position: absolute;
      bottom: 15vh;
      @media screen and (min-width: 768px) {
        bottom: 5vmax;
      }

      button {
        transition: all ease-in-out 0.2s;

        &.disabled {
          opacity: 0.75;
        }
      }
    }
  }
}

/**
 * Basically the gallery screws up when viewed from within the side panel (news, events etc.)
 * The idea here is to basically move it to the left, but take into account the width of the panel
 * Think these are the correct breakpoints
 **/
.c-panel {
  .c-gallery__modal {
    transform: translateX(calc(-100vw + 90%));
    @media screen and (min-width: 950px) {
      transform: translateX(calc(-100vw + 860px));
    }
    @media screen and (min-width: 1024px) {
      transform: translateX(calc(-100vw + 70%));
    }
    @media screen and (min-width: 1170px) {
      transform: translateX(calc(-100vw + 60%));
    }
    @media screen and (min-width: 1440px) {
      transform: translateX(calc(-100vw + 860px));
    }
  }
}

.glide {
  &__slide {
    cursor: pointer;
    overflow: hidden;
    .c-media-image {
      height: 200px;
    }

    img {
      width: auto !important;
      height: 120% !important;
      max-width: inherit !important;
      margin: 0 auto;
      display: block;

      @supports (object-fit: cover) {
        min-height: 75px;
        max-width: 100% !important;
        width: 100% !important;
        min-width: 75px;
        height: 100% !important;
        object-fit: cover;
        height: 200px !important;
      }
    }
  }
  &__bullet {
    background: $colour-nhs-pale-grey;
    border-radius: 3px;
    box-sizing: border-box;
    color: $colour-nhs-core-blue;
    display: inline-block;
    font-size: 20px;
    font-weight: 400;
    padding: 10px 20px;
    text-decoration: none;
    margin: 10px 10px 0 0;
    transition: all ease-in-out 0.2s;
    border: none;
    cursor: pointer;

    &--active {
      background: $colour-nhs-core-blue;
      color: white;
    }
  }
}
</style>